import { render, staticRenderFns } from "./radioBoxInput.vue?vue&type=template&id=92712346&scoped=true&"
import script from "./radioBoxInput.vue?vue&type=script&lang=js&"
export * from "./radioBoxInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92712346",
  null
  
)

export default component.exports